import { SxProps } from "@mui/material";
import { renderEventNameWithIdNumber } from "misc/renderHelpers";
import { AutocompleteArrayInput, AutocompleteArrayInputProps, RaRecord, ReferenceArrayInput } from "react-admin";

import { EventRecordType } from "../../pages/Event/Event.types";
import { EventSelectInputOption } from "./EventSelectInput";

export type EventSelectManyInputPropsType = {
  onChange?: AutocompleteArrayInputProps["onChange"];
  validate?: AutocompleteArrayInputProps["validate"] | false;
  label?: string;
  eventBaseId?: number | undefined;
  filter?: Record<string, unknown>;
  perPage?: number;
  source?: string;
  reference?: string;
  defaultValue?: unknown[];
  alwaysOn?: boolean;
  key?: string;
  sx?: SxProps;
};

export default function EventSelectManyInput(props: EventSelectManyInputPropsType) {
  const {
    onChange,
    validate,
    label,
    reference = "events",
    eventBaseId,
    filter = {},
    perPage = 100,
    source = "event",
    defaultValue,
    sx,
    ...rest
  } = props;

  const composedFilter = { ...(eventBaseId ? { order_by_event_base_id: eventBaseId } : {}), ...filter };
  const sort = {
    field: `${eventBaseId ? "event_base_id_ordering," : ""}event_base__name,-first_day`,
    order: "ASC" as const,
  };

  return (
    <ReferenceArrayInput
      source={source}
      filter={composedFilter}
      reference={reference}
      sort={sort}
      perPage={perPage}
      {...rest}
    >
      <AutocompleteArrayInput
        parse={(v: string) => (v.length == 0 ? null : v)}
        inputText={(choice: EventRecordType) => `${renderEventNameWithIdNumber(choice)}`}
        optionText={<EventSelectInputOption />}
        onChange={onChange}
        fullWidth
        validate={validate ? validate : undefined}
        groupBy={(choice: RaRecord) => (choice as EventRecordType).meta.event_base_name}
        label={label}
        filterToQuery={(search: string) => ({ search })}
        defaultValue={defaultValue}
        sx={sx}
      />
    </ReferenceArrayInput>
  );
}
